<template>
    <div>
        <notifications></notifications>
        <loading-animation :show-loading="showLoading"></loading-animation>
        <router-view v-show="!showLoading" :key="$route.fullPath" @show-loading="loadingStatus"></router-view>
    </div>
</template>

<script>
import axios from "axios";
import LoadingAnimation from "./components/LoadingAnimation";

export default {
    components: {LoadingAnimation},
    data(){
        return{
            showLoading: false
        }
    },
    methods: {
        toggleNavOpen() {
            let root = document.getElementsByTagName('html')[0];
            root.classList.toggle('nav-open');
        },
        loadingStatus(value){
            if (!value){
                const that = this;
                setTimeout(function () {
                    that.showLoading = false;
                },2000)
            }else{
                this.showLoading = true;
            }

        },
    },
    mounted() {
        this.$watch('$sidebar.showSidebar', this.toggleNavOpen)
    },
    created: function () {

        axios.interceptors.request.use(
            (config) => {
                $('.progress-bar').animate({width: "90%"}, 100);
                return config;
            },
            (error) => {
                setTimeout(() => {
                    $('.progress-bar').animate({width: "0%"}, 1);
                },1000);
                return Promise.reject(error);
            });
        axios.interceptors.response.use(
            (response) => {
                $('.progress-bar').animate({width: "100%"}, 100);
                setTimeout(() => {$('.progress-bar').animate({width: "0%"}, 1);},1000);
                return response;
            },
            (error) => {
                setTimeout(() => {$('.progress-bar').animate({width: "0%"}, 1);},1000);
                return Promise.reject(error);
            });
    },
};
</script>

<style lang="scss">
.progress{
    box-shadow: none!important;
}
.delay {
    animation-delay: 1.0s;
}
</style>
